import { Component, OnInit, OnDestroy } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';
import { BookingService } from '@ibe/services';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import { Observable } from 'rxjs';
import { BookedTrip } from '@ibe/models';
import { takeWhile } from 'rxjs/operators';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { EXTRAS_ANCILLARY_GUARANTEE_FUND, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { INDRAGoogleAnalyticsService, EVENT_PRODUCT_BRAND_DANISH_FUND, EVENT_ACTION_ADD_CART, EVENT_ACTION_REM_CART } from '@ibe.services/google.analytics.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';

@Component({
	selector: 'app-danish-guarantee-fund',
	templateUrl: './danish-guarantee-fund.indra.component.html',
	styleUrls: ['./danish-guarantee-fund.component.scss']
})
export class INDRADanishGuaranteeFundComponent implements OnInit, OnDestroy {
	private isAlive = true;
	// danishGuaranteeFund: boolean = false;

	// Market currency symbol (eg. €, $, £, R$)
	currency;

	booked_trip;

	danishGuaranteeFund: any;
	hasDanishFund: boolean = false;
	totalAmount = 0;
	pricePerPassenger = 0;

	showAddError: boolean = false;
	showRemoveError: boolean = false;
	isModificationDisallowed: boolean = false;

	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		private sidebarService: SidebarService,
		private bookingService: BookingService,
		private store: Store<fromStore.State>,
		protected bfmStorage: INDRABFMDataStorageService,
		protected ancillaryService: INDRAAncillariesService,
		private currencyService: INDRACurrencyService,
		private googleAnalytics: INDRAGoogleAnalyticsService,
		protected paymentInfoService: PaymentService
	) {

		const thirdPartyAncillaries = this.bfmStorage.INDRA_getThirdPartyAncillaries();
		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();

		const danishFund = thirdPartyAncillaries.find(bundle =>
			bundle.ancillaryList[0].type == EXTRAS_ANCILLARY_GUARANTEE_FUND
		);

		if (danishFund) {
			this.danishGuaranteeFund = danishFund.danishFundProperties;
			this.currency =  this.currencyService.INDRA_getCurrencySymbol(this.danishGuaranteeFund.currency).unit;
		}

		if (this.booked_trip.danish_fund) {
			this.hasDanishFund = true;
		}

		this.pricePerPassenger = this.danishGuaranteeFund.priceByPaxType[0].price;
		
		// get 'isBookingCreated' if existing in URL query params
		const isBookingCreatedParam = this.route.snapshot.paramMap.get('isBookingCreated');
		if (isBookingCreatedParam === 'true') {
			this.isModificationDisallowed = true;
		} 
	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}

	ngOnInit() {
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
	}

	INDRA_danishGuaranteeFundChanged() {
		if (!this.booked_trip.danish_fund && this.danishGuaranteeFund) {
			const request = {
				provider: 'DANISH_FUND',
				idReservation: 'DR_001',
				description: 'danish guarantee fund',
				currency: this.danishGuaranteeFund.currency,
				amount: this.danishGuaranteeFund.totalPrice,
				status: 'OK',
				bookableItemId: 'DR_001',
				extraInfo: {}
			};
			this.ancillaryService.INDRA_addExternalReservation(request, 'GUARANTEE_FUND').subscribe(res => {
				if (res && res.status === '200' && res.reservations) {
					// this.isLoading = true;
					const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
					booked_trip.danish_fund = res.reservations.DANISH_FUND;
					this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
					this.INDRA_registerGA_danishFund();
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.INDRA_handleClose();
					// this.isLoading = false;
				} else {
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.showAddError = true;
					// this.isLoading = false;
				}
			}, error => {
				this.paymentInfoService.setUpdateBookingTotals(true);
				if (error) {
					this.showAddError = true;
					// this.isLoading = false;
				}
			});
		} else {
			this.ancillaryService.INDRA_removeExternalReservation('DANISH_FUND').subscribe(res => {
				if (res && res.status === '200') {
					const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
					const bookedTripDanishFund = booked_trip.danish_fund[0];
					booked_trip.danish_fund = null;
					this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
					this.INDRA_removeGA_danishFund(bookedTripDanishFund);
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.INDRA_handleClose();
					// this.isLoading = false;
				} else {
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.showRemoveError = true;
					// this.isLoading = false;
				}
			}, error => {
				this.paymentInfoService.setUpdateBookingTotals(true);
				if (error) {
					this.showRemoveError = true;
					// this.isLoading = false;
				}
			});
		}
	}

	INDRA_registerGA_danishFund() {
		const activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
		let eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_DANISH_FUND, activeBooking.danish_fund[0]);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);

		this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
	}

	INDRA_removeGA_danishFund(bookedTripDanishFund) {
		let eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_DANISH_FUND, bookedTripDanishFund);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);

		this.googleAnalytics.INDRA_GA_removeFromCart(this.currency, eventDataLayerObject);
	}

}
